module.exports = __webpack_public_path__ + "img/0030.15ddd67e.jpg";